export default [
    'sendgroupmsg',
    'getquestioninfo',
    'getcompetitionmonitor',
    'getindividualcompetitionmonitor',
];


// WEBPACK FOOTER //
// ./src/constants/apiContext.js